import BAuth from "./BAuth"
import axios from "axios"

export default class BRequest
{
	static getCaller()
	{
		return "web";
	}

	static call(method, url, data, config) {
		if (method == "get") {
			url = url + "?" + (new URLSearchParams(data)).toString();
			data = null;
		}

		if (!config) {
			config = {};
		}

		config.method = method;
		config.url = url;
		config.data = data;
		config.headers = {
			"Authorization": BAuth.getAuthorizationHeader(),
			"X-Auth": BAuth.getAuthorizationHeader(),
			"X-Caller": this.getCaller(),
			...(config.headers ?? {}),
		};

		return axios(config);
	};

	static get(url, data, config)
	{
		return this.call("get", url, data, config);
	}

	static post(url, data, config)
	{
		return this.call("post", url, data, config);
	}

	static put(url, data, config)
	{
		return this.call("put", url, data, config);
	}

	static patch(url, data, config)
	{
		return this.call("patch", url, data, config);
	}

	static delete(url, data, config)
	{
		return this.call("delete", url, data, config);
	}
}
